import { render, staticRenderFns } from "./pricelist-form.vue?vue&type=template&id=7b495e32&"
import script from "./pricelist-form.vue?vue&type=script&lang=js&"
export * from "./pricelist-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports